import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import _slicedToArray from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRunner as e } from "react-runner";
export * from "react-runner";
import t, { useState as r, useEffect as n, useCallback as o, useRef as a, useMemo as l, createContext as c, useContext as s } from "react";
import p from "react-simple-code-editor";
import m, { Prism as i } from "prism-react-renderer";

var d = function d(t) {
  var o = t.scope,
      a = t.sourceCode,
      l = t.disableCache,
      c = t.transformCode;

  var _r = r(a),
      _r2 = _slicedToArray(_r, 2),
      s = _r2[0],
      p = _r2[1],
      _e = e({
    code: c ? c(s) : s,
    scope: o,
    disableCache: l
  }),
      m = _e.element,
      i = _e.error;

  return n(function () {
    p(a);
  }, [a]), {
    element: m,
    error: i,
    code: s,
    onChange: p
  };
};

function u() {
  return u = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }, u.apply(this, arguments);
}

function y(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) {
    t.indexOf(r = a[n]) >= 0 || (o[r] = e[r]);
  }

  return o;
}

var g = {
  plain: {
    color: "#ffffff",
    backgroundColor: "#282c34"
  },
  styles: [{
    types: ["comment", "block-comment", "prolog", "doctype", "cdata"],
    style: {
      color: "#b2b2b2"
    }
  }, {
    types: ["property", "number", "function-name", "constant", "symbol", "deleted"],
    style: {
      color: "#b2b2b2"
    }
  }, {
    types: ["boolean"],
    style: {
      color: "#ff8b50"
    }
  }, {
    types: ["tag"],
    style: {
      color: "#fc929e"
    }
  }, {
    types: ["string"],
    style: {
      color: "#8dc891"
    }
  }, {
    types: ["punctuation"],
    style: {
      color: "#88c6Be"
    }
  }, {
    types: ["selector", "char", "builtin", "inserted"],
    style: {
      color: "#d8dee9"
    }
  }, {
    types: ["function"],
    style: {
      color: "#79b6f2"
    }
  }, {
    types: ["operator", "entity", "url", "variable"],
    style: {
      color: "#d7deea"
    }
  }, {
    types: ["keyword"],
    style: {
      color: "#c5a5c5"
    }
  }, {
    types: ["class-name"],
    style: {
      color: "#fac863"
    }
  }, {
    types: ["important"],
    style: {
      fontWeight: "400"
    }
  }, {
    types: ["bold"],
    style: {
      fontWeight: "700"
    }
  }, {
    types: ["italic"],
    style: {
      fontStyle: "italic"
    }
  }, {
    types: ["entity"],
    style: {
      cursor: "help"
    }
  }, {
    types: ["namespace"],
    style: {
      opacity: .7
    }
  }]
},
    h = ["children", "language", "theme", "padding", "noWrapper", "noWrap", "className", "style"],
    f = function f(e) {
  var r = e.children,
      _e$language = e.language,
      n = _e$language === void 0 ? "jsx" : _e$language,
      _e$theme = e.theme,
      o = _e$theme === void 0 ? g : _e$theme,
      _e$padding = e.padding,
      a = _e$padding === void 0 ? 10 : _e$padding,
      l = e.noWrapper,
      c = e.noWrap,
      s = e.className,
      p = e.style,
      d = y(e, h);
  /*#__PURE__*/

  return t.createElement(m, {
    code: r || "",
    language: n,
    Prism: i,
    theme: o
  }, function (e) {
    var r = e.className,
        n = e.style,
        o = e.tokens,
        m = e.getLineProps,
        i = e.getTokenProps;
    var y = o.map(function (e, r) {
      return (
        /*#__PURE__*/
        t.createElement("div", m({
          line: e,
          key: r
        }), e.map(function (e, r) {
          return (
            /*#__PURE__*/
            t.createElement("span", i({
              token: e,
              key: r
            }))
          );
        }))
      );
    });
    return l ? y :
    /*#__PURE__*/
    t.createElement("pre", u({
      className: s ? r + " " + s : r,
      style: u({}, n, {
        margin: 0,
        padding: a,
        whiteSpace: c ? "pre" : "pre-wrap"
      }, p)
    }, d), y);
  });
},
    b = ["defaultValue", "value", "language", "theme", "padding", "onChange"],
    C = function C(e) {
  var n = e.defaultValue,
      c = e.value,
      _e$language2 = e.language,
      s = _e$language2 === void 0 ? "jsx" : _e$language2,
      _e$theme2 = e.theme,
      m = _e$theme2 === void 0 ? g : _e$theme2,
      _e$padding2 = e.padding,
      i = _e$padding2 === void 0 ? 10 : _e$padding2,
      d = e.onChange,
      h = y(e, b);

  var _r3 = r(n || ""),
      _r4 = _slicedToArray(_r3, 2),
      C = _r4[0],
      v = _r4[1],
      E = void 0 !== c,
      k = o(function (e) {
    return (
      /*#__PURE__*/
      t.createElement(f, {
        language: s,
        theme: m,
        noWrapper: !0
      }, e)
    );
  }, [s, m]),
      W = a(d);

  W.current = d;
  var j = o(function (e) {
    E || v(e), null == W.current || W.current(e);
  }, [E]),
      x = l(function () {
    return u({}, m.plain, h.style);
  }, [m.plain, h.style]);
  /*#__PURE__*/

  return t.createElement(p, u({}, h, {
    padding: i,
    value: E ? c : C,
    highlight: k,
    onValueChange: j,
    style: x
  }));
},
    v = c({}),
    E = function E() {
  return s(v);
},
    k = function k(e) {
  var r = e.children,
      n = e.scope,
      _e$code = e.code,
      o = _e$code === void 0 ? "" : _e$code,
      _e$language3 = e.language,
      a = _e$language3 === void 0 ? "jsx" : _e$language3,
      _e$theme3 = e.theme,
      l = _e$theme3 === void 0 ? g : _e$theme3,
      c = e.disableCache,
      s = e.transformCode;

  var _d = d({
    scope: n,
    sourceCode: o,
    disableCache: c,
    transformCode: s
  }),
      p = _d.element,
      m = _d.error,
      i = _d.code,
      u = _d.onChange;
  /*#__PURE__*/


  return t.createElement(v.Provider, {
    value: {
      element: p,
      error: m,
      code: i,
      onChange: u,
      language: a,
      theme: l
    }
  }, r);
},
    W = function W(e) {
  var _E = E(),
      r = _E.code,
      n = _E.language,
      o = _E.theme,
      a = _E.onChange;
  /*#__PURE__*/


  return t.createElement(C, u({
    value: r,
    language: n,
    theme: o,
    onChange: a
  }, e));
},
    j = ["Component"],
    x = function x(e) {
  var _e$Component = e.Component,
      r = _e$Component === void 0 ? "div" : _e$Component,
      n = y(e, j);

  var _E2 = E(),
      o = _E2.element;
  /*#__PURE__*/


  return t.createElement(r, n, o);
},
    O = function O(e) {
  var _E3 = E(),
      r = _E3.error;

  return r ?
  /*#__PURE__*/
  t.createElement("pre", e, r) :
  /*#__PURE__*/
  t.createElement(t.Fragment, null);
};

export { f as CodeBlock, C as CodeEditor, v as LiveContext, W as LiveEditor, O as LiveError, x as LivePreview, k as LiveProvider, g as defaultTheme, E as useLiveContext, d as useLiveRunner };